var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getElementData)?_c('div',{class:_vm.title.toLowerCase()},[_vm._v(" "+_vm._s(_vm.information)+" "),(_vm.showComments)?_c('CommentsBadge',{attrs:{"item":{
      id: _vm.item.id,
      commentsAmount: _vm.amount,
    }}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }